<template>
  <div id="contenedor-eliminar-etiqueta">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Etiqueta </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la etiqueta "{{etiquetaEliminar.nombre}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarEtiqueta"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixEtiquetas from './mixEtiquetas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarEtiqueta',
  mixins: [mixEtiquetas],
  props: {
    etiquetaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
